import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { useSession } from 'packages/@slerp/accounts'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'
import { LIST_INTEGRATIONS } from './queries'
import { ShipdayIntegration } from '../Manage/ManageShipday/types'
import { useIntegration } from '../hooks/useIntegration'
import { PARTNER_SLUGS } from '../constants'
import { LoaderProps } from 'router/Loaders/types'

const PROVIDER = PARTNER_SLUGS.SHIPDAY

export const ShipdayIntegrationsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const { addMessage } = useMessageStore()
  const {
    shipdayIntegrations,
    setShipdayIntegrations,
    setRefetchShipdayIntegrations
  } = useIntegration()

  const [isLoaded, setIsLoaded] = useState(false)

  const { data, loading, refetch } = useQuery<{
    listIntegrations: ShipdayIntegration[]
  }>(LIST_INTEGRATIONS, {
    skip: !merchant?.id || shipdayIntegrations.length > 0,
    variables: { merchant_id: merchant?.id, provider: PROVIDER },
    onError: () => {
      addMessage({ type: 'error', content: 'Failed to load integrations' })
    }
  })

  useEffect(() => {
    if (!refetch) {
      return
    }

    setRefetchShipdayIntegrations(
      (() => refetch) as unknown as () => Promise<unknown>
    )
  }, [refetch])

  useEffect(() => {
    if (data?.listIntegrations) {
      setShipdayIntegrations(data.listIntegrations)
    }
  }, [data])

  useEffect(() => {
    setIsLoaded(isParentLoaded && (!merchant?.id || !loading))
  }, [loading, isParentLoaded, merchant?.id])

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
